/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./auth-layout.component";
var styles_AuthLayoutComponent = [];
var RenderType_AuthLayoutComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AuthLayoutComponent, data: {} });
export { RenderType_AuthLayoutComponent as RenderType_AuthLayoutComponent };
export function View_AuthLayoutComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i0.ɵdid(1, 212992, null, 0, i1.RouterOutlet, [i1.ChildrenOutletContexts, i0.ViewContainerRef, i0.ComponentFactoryResolver, [8, null], i0.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_AuthLayoutComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-layout", [], null, null, null, View_AuthLayoutComponent_0, RenderType_AuthLayoutComponent)), i0.ɵdid(1, 49152, null, 0, i2.AuthLayoutComponent, [], null, null)], null, null); }
var AuthLayoutComponentNgFactory = i0.ɵccf("app-layout", i2.AuthLayoutComponent, View_AuthLayoutComponent_Host_0, {}, {}, []);
export { AuthLayoutComponentNgFactory as AuthLayoutComponentNgFactory };
